module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMhCgpMZXQncyBjYWxjdWxhdGUgcmVhbCBmaWJvbmFjY2kgbnVtYmVycyB0b2dldGhlcjogMSwgMSwgMiwgMywgNSwgOCwgMTMsIDIxLCAzNCwgNTUsIDg5LCAxNDQsIDIzMy4uLi4K"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/fakeFibonacci_complete.md
// module id = 1372
// module chunks = 0